import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

export default {
  state: {
    id: '',
    nom: '',
    code: '',
    contactTel1: '',
    contactTel2: '',
    contactNom: '',
    contactEmail: '',
    adresse: '',
    complementAdresse: '',
    codePostal: 0,
    ville: '',
    departement: '',
    societe: 0,
    typeOperations: [],
    typeErp: [],
    client: 0,
    etat: 1,
    listProjets: null,
    numeroAffaire: ''
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/projectForm/index.js